
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Product } from '@/types/product';
import moment from 'moment';

@Component
export default class ProductListTile extends Vue {
  @Prop() product!: Product;

  get createdDate(): string {
    return this.fromNow(this.product.created_at as string);
  }

  get updatedDate(): string {
    return this.fromNow(this.product.updated_at as string);
  }

  get imageExists(): boolean {
    return this.product.logo !== null;
  }

  get imageUrl(): string {
    const find =
      'https://s3.eu-west-2.amazonaws.com/cdn.alternativebusinessfunding.co.uk';
    const replace =
      'https://cdn.alternativebusinessfunding.co.uk/fit-in/180x180';
    return this.product.logo!.replace(find, replace);
  }

  fromNow(fromDate: string): string {
    moment.locale('en-gb');
    const fromMoment: moment.Moment = moment(fromDate);
    const now: moment.Moment = moment();
    return now.diff(fromMoment, 'days') > 1
      ? fromMoment.calendar()
      : fromMoment.fromNow();
  }
}
